'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const StandardTileOverlay = renderWithRef('StandardTileOverlay', null, (a, o)=>jsx(RenderComp, {
        root: "div",
        forwardedRef: o,
        classNames: [
            'swan-standard-tile-overlay'
        ],
        props: a,
        children: a.children
    }));

export { StandardTileOverlay };
